const AddDataSeqNO = (data: any[]) => {
    return (data ?? []).map((item, index) => {
        item.seqNO = index + 1;
        return item;
    });
}

export default {
    AddDataSeqNO
}